import styled from 'styled-components'

const MyDiv = styled.div`
.flex_header{
  align-items: center;
  justify-content: space-between;
}

// .grid{
//  grid-template-columns: repeat(5, 1fr);
// }

.btn{
margin-top:35px;
  width:100%;
  font-family: 'Poppins', sans-serif;  
  color:white;
  font-weight:400px;
  font-size:14px;
  background-color: #006838;
  border-radius: 44px;
  &:hover{
  background-color: #006838;
  color:white;
  }
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: #fff;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  height: 100%;
 
}



.react-calendar {
    font-family: 'Poppins', sans-serif;   
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  }

  .react-calendar__tile {
    padding: 6px 0;
  }

  .react-calendar__navigation button {
    min-width: 28px;
    font-size: 12px;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }

`
export default MyDiv
